import { Reducer } from 'redux'

import { DadosBancariosState, DadosBancariosTypes } from './types'

const INITIAL_STATE: DadosBancariosState = {
  bancos: [],
  bancoSelecionado: '',
  bancoNome: '',
  tipoContaSelecionado: 1,
  tipoCreditoInss: undefined,
  agencia: '',
  contaDadosBancarios: '',
  digito: '',
  isBankAccountEditable: true,
  loading: false,
}

const reducer: Reducer<DadosBancariosState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case DadosBancariosTypes.BANCOS_REQUEST:
      return { ...state, loading: true }
    case DadosBancariosTypes.BANCOS_SUCCESS:
      return { ...state, bancos: action.payload, loading: false }
    case DadosBancariosTypes.SET_BANCOS_ERROR:
      return { ...state, loading: false }
    case DadosBancariosTypes.SET_BANCOS_LOADING:
      return { ...state, loading: action.payload }
    case DadosBancariosTypes.SET_BANCO_SELECIONADO:
      return { ...state, bancoSelecionado: action.payload }
    case DadosBancariosTypes.SET_BANCO_NOME:
      return { ...state, bancoNome: action.payload }
    case DadosBancariosTypes.SET_TIPO_CONTA:
      return { ...state, tipoContaSelecionado: action.payload }
    case DadosBancariosTypes.SET_TIPO_CREDITO_INSS:
      return { ...state, tipoCreditoInss: action.payload }
    case DadosBancariosTypes.SET_AGENCIA:
      return { ...state, agencia: action.payload }
    case DadosBancariosTypes.SET_CONTA_DADOS_BANCARIOS:
      return { ...state, contaDadosBancarios: action.payload }
    case DadosBancariosTypes.SET_DIGITO:
      return { ...state, digito: action.payload }
    case DadosBancariosTypes.CLEAR_ACCOUNT_FIELDS:
      return {
        ...state,
        bancoSelecionado: '',
        bancoNome: '',
        tipoContaSelecionado: undefined,
        agencia: '',
        contaDadosBancarios: '',
        digito: '',
      }
    case DadosBancariosTypes.SET_IS_BANK_ACCOUNT_EDITABLE:
      return { ...state, isBankAccountEditable: action.payload }
    case DadosBancariosTypes.RESET:
      return { ...INITIAL_STATE }
    default:
      return state
  }
}

export default reducer
